import React, { useState } from 'react';
import { Box, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { getEcometriPlusEmbedUrl } from '../../constants.js/ecometriPlusConfig';

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        margin: theme.breakpoints.up('sm') ? '-32px -24px -136px' : '-8px -8px -72px',
        width: theme.breakpoints.up('sm') ? 'calc(100% + 48px)' : 'calc(100% + 16px)',
        height: theme.breakpoints.up('sm') ? 'calc(100vh - 64px)' : 'calc(100vh - 120px)',
        minHeight: 420,
        background: '#fff',
        overflow: 'hidden',
    },
    loader: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1,
    },
    frame: {
        width: '100%',
        height: '100%',
        border: 0,
        display: 'block',
    },
}));

const EcometriPlusPage = () => {
    const classes = useStyles();
    const embedUrl = getEcometriPlusEmbedUrl();
    const [loading, setLoading] = useState(true);

    return (
        <Box className={classes.root}>
            {loading && <CircularProgress className={classes.loader} size={32} />}
            <iframe
                className={classes.frame}
                src={embedUrl}
                title="Ecometri AI"
                allow="clipboard-read; clipboard-write; fullscreen"
                onLoad={() => setLoading(false)}
            />
        </Box>
    );
};

export default EcometriPlusPage;
